import { authAPI } from '../api';

// Кеш для предотвращения множественных одновременных запросов токена
let tokenCache = null;
let tokenPromise = null;
let tokenCacheTime = 0;
const TOKEN_CACHE_DURATION = 600000; // Кешируем токен на 10 минут (токен живет 15 минут)

export const clearTokenCache = () => {
  tokenCache = null;
  tokenPromise = null;
  tokenCacheTime = 0;
};

export const refreshToken = async () => {
  const now = Date.now();
  
  // Если токен в кеше и еще не истек, возвращаем его
  if (tokenCache && (now - tokenCacheTime) < TOKEN_CACHE_DURATION) {
    return tokenCache;
  }

  // Если запрос уже выполняется, возвращаем тот же промис
  if (tokenPromise) {
    return tokenPromise;
  }

  // Создаем новый промис для получения токена
  tokenPromise = (async () => {
    try {
      // Получаем токен для WebSocket подключений
      // Токен теперь в HttpOnly куках, просто получаем его значение
      const response = await authAPI.getToken();
      const token = response.data.token;
      
      // Кешируем токен
      tokenCache = token;
      tokenCacheTime = Date.now();
      
      return token;
    } catch (error) {
      // Если не удалось получить токен, очищаем кеш
      clearTokenCache();
      // Если не удалось получить токен, возможно нужно обновить
      // Интерцептор в api.js автоматически обработает это
      throw error;
    } finally {
      // Очищаем промис после завершения запроса
      tokenPromise = null;
    }
  })();

  return tokenPromise;
};
